import { OFFER_DEEP_DISCOUNT_PERCENT } from './offer-constants'

export interface FloorGap {
	/** The floor price the offer is measured against, in sats. */
	anchorSats: number
	/** How far under the floor the offer sits, 0 when at or above it. */
	percentBelow: number
	/** At least OFFER_DEEP_DISCOUNT_PERCENT under the floor. */
	deep: boolean
}

/** How an offer compares with the floor price; null when there is no floor to compare with. */
export function floorGap(priceSats: number, anchorSats: number | null | undefined): FloorGap | null {
	if (!anchorSats || !Number.isFinite(anchorSats) || anchorSats <= 0 || !Number.isFinite(priceSats)) return null
	const percentBelow = priceSats < anchorSats ? ((anchorSats - priceSats) / anchorSats) * 100 : 0
	return { anchorSats, percentBelow, deep: percentBelow >= OFFER_DEEP_DISCOUNT_PERCENT }
}

/**
 * The discount as the seller reads it. Rounded down, so a deep discount never
 * reads as smaller than the threshold that triggered it (30.0 to 30.99 reads 30).
 */
export function deepDiscountPercent(gap: FloorGap): number {
	return Math.floor(gap.percentBelow)
}
